module.exports = __webpack_public_path__ + "img/deviceSystem_2.5ae546e3.jpg";